"use client";
import { useEffect, useState } from "react";

export default function AddToGroupPage() {
  const [requests, setRequests] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchRequests = async () => {
      try {
        const response = await fetch("/api/pending"); // ✅ call proxy route
        if (!response.ok) throw new Error("Failed to fetch requests");
        const data = await response.json();
        setRequests(data);
      } catch (err: any) {
        setError(err.message);
      }
    };

    fetchRequests();
  }, []);

  return (
    <div>
      <h1>Pending Requests</h1>
      {error && <p style={{ color: "red" }}>{error}</p>}
      <ul>
        {requests.map((req, idx) => (
          <li key={idx}>{JSON.stringify(req)}</li>
        ))}
      </ul>
    </div>
  );
}
